import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

const softLaunchIMISIds = [
    // ICSC technology team
    1702270,
    1706642,
    1363632,
    1469258,
    1251357,
    213628,
    1645001,
    1712040,
    1698359,

    // test accounts
    1632656,
    1675958,
    8011043,
    1675959,
    1756586,
    1675964,
];

const useSoftLaunchMembers = accountId => {
    const [isSoftLaunch, setIsPartOfSoftLaunch] = useState(true);

    useEffect(() => {
        if (!accountId) return;
        setIsPartOfSoftLaunch(softLaunchIMISIds.includes(accountId));
    }, [accountId]);

    return window.isStaging ? true : isSoftLaunch;
};

useSoftLaunchMembers.propTypes = {
    accountId: PropTypes.number,
};

export default useSoftLaunchMembers;
